import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ConfirmationModal,
  Flex,
  Text,
  TextButton,
  Tooltip,
  useOpenModal,
} from '@modusign/design-system';
import { useSelector } from 'react-redux';

import { ContentBox } from '@app/features/workspaceManagement';
import { getName } from '@app/store/user/user/selectors';

export function ChangeToPrivateLabelButton({
  needConfirm,
  onConfirm,
}: {
  needConfirm?: boolean;
  onConfirm: () => void;
}) {
  const userName = useSelector(getName);
  const openModal = useOpenModal();

  return (
    <Tooltip
      content={
        <Text textAlign="center">
          일부 멤버·그룹만 라벨을
          <br />
          이용할 수 있게 설정합니다.
        </Text>
      }
      placement="top-start"
    >
      <TextButton
        onClick={() => {
          if (needConfirm) {
            openModal(({ isOpen, onClose }) => (
              <ConfirmationModal
                confirmButtonLabel="변경"
                isOpen={isOpen}
                maxWidth="xs"
                title="라벨 보기 제한"
                variant="warning"
                onClose={onClose}
                onConfirm={() => {
                  onConfirm();
                  onClose();
                }}
              >
                <Flex flexDirection="column" gap={6}>
                  <Text as="p" textAlign="center">
                    {`'${userName}'님만 이용할 수 있는 라벨로 변경할까요?`}
                    <br />
                    다른 멤버·그룹을 추가할 수도 있습니다.
                  </Text>
                  <ContentBox>
                    <Text fontSize="sm">
                      이 라벨이 템플릿에 적용되어 있을 경우 다른 멤버의 라벨 사용이 제한될 수
                      있습니다.
                    </Text>
                  </ContentBox>
                </Flex>
              </ConfirmationModal>
            ));
          } else {
            onConfirm();
          }
        }}
      >
        <FontAwesomeIcon icon={faEyeSlash} style={{ marginRight: '2px' }} />
        보기 제한
      </TextButton>
    </Tooltip>
  );
}
